import { customerApi } from "@/customer/api";

/**
 * Phase 7 — request a fresh short-lived signed download URL and trigger the browser
 * download. The URL is never persisted by us; the server logs every attempt.
 */
export async function requestSecureDownload(purchasedPhotoId) {
  const r = await customerApi.post(`/customer/downloads/${purchasedPhotoId}`);
  const { download_url, filename } = r.data;
  // Trigger download in a way that respects the server's Content-Disposition header
  // and bypasses popup-blockers.
  const a = document.createElement("a");
  a.href = download_url;
  a.rel = "noopener";
  a.download = filename || "";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 0);
  return r.data;
}
